import { Grid } from "@mui/material";

const CustomTableGrid = props => {
    return (
        <Grid className="table-grid h-100" item xs={12} sm={12} md={12} lg={12} xl={12}>
            {props.item}
        </Grid>
    )
}
export default CustomTableGrid;